
















import { mapGetters } from 'vuex';

export default {
    name: "OnsiteSearchGroupResultItem",
    props: {
        groupResult: {
            type: Object
        }
    },
    computed: mapGetters(['getTranslations'])
    
}
